/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export enum TextureMaterialType {
    Unknown = 0,
    Texture = 1,
    Cladding = 2,
}
